import React from 'react';

const MediaQueryContext = React.createContext();

export default MediaQueryContext;